import React, { Fragment, useMemo } from 'react'
import PaperPrint from './PaperPrint'

const EMPTY_ROW = {
  url: '',
  fileName: '',
  base64: '',
  lotteryId: '',
  isPrized: false,
  id: '',
}

const getRows = (lotteries) => {
  const rowSize = 40
  const rows = []

  for (let i = 0; i < lotteries.length; i += rowSize) {
    const row = lotteries.slice(i, i + rowSize)
    const filledArray = Array.from({ length: rowSize }, (_, index) => row[index] || EMPTY_ROW)
    rows.push(filledArray)
  }

  return rows
}

const getListItems = (rows, idStart) => {
  const listItems = rows.map((row) => {
    idStart += 1
    return ({ ...row, lotteryId: row.lotteryId.slice(6), id: idStart })
  })

  return listItems
}

const getCountPrize = (rows) => {
  const countLottery = rows.filter((row) => row.lotteryId).length
  const countLotteryIsPrize = rows.filter((row) => row.lotteryId && row.isPrize === true).length
  const countPrize = `${countLotteryIsPrize}/${countLottery}`

  return countPrize
}

const getContainers = (rows) => {
  const containers = rows.map((row) => {
    return {
      containerLefts: {
        listItemLefts: getListItems(row.slice(0, 10), 0),
        listItemRights: getListItems(row.slice(10, 20), 10),
        countPrize: getCountPrize(row.slice(0, 20)),
      },
      containerRights: {
        listItemLefts: getListItems(row.slice(20, 30), 0),
        listItemRights: getListItems(row.slice(30, 40), 10),
        countPrize: getCountPrize(row.slice(20, 40)),
      },
    }
  })

  return containers
}

const getPapers = (containers) => {
  const paperSize = 6
  const papers = []

  for (let i = 0; i < containers.length; i += paperSize) {
    const chunk = containers.slice(i, i + paperSize)
    papers.push(chunk)
  }

  return papers
}

const Print = ({ lotteries, fullNameInContainer, fullNameBelowPaper, foundPrize }) => {

  const lotteryToPrint = useMemo(() => {
    const rows = getRows(lotteries)
    const containers = getContainers(rows)
    const papers = getPapers(containers)

    return papers

  }, [lotteries])

  return (
    <Fragment>
      {lotteryToPrint.map((papers, index) => {
        return <PaperPrint key={index} papers={papers} fullNameInContainer={fullNameInContainer} fullNameBelowPaper={fullNameBelowPaper} />
      })}
      <GroupPrizePrint foundPrize={foundPrize} />
    </Fragment>
  )
}

export default Print

const GroupPrizePrint = ({ foundPrize }) => {
  return (
    <div className="d-none paper-print">
      {Object.keys(foundPrize).map((prizeName) => {
        const prizes = foundPrize[prizeName]

        return <div className="group-prize-name" key={prizeName}>{prizeName} ทั้งหมด {prizes.length} ใบ</div>
      })}
    </div>
  )
}
